import { Row } from "./row";
import { EntryType } from "../Compo/CompoPage";

export type CollabConfirmationState = "CONFIRMED" | "UNASKED" | "PENDING";

export interface EntryJSON {
  id: number;
  user_id: number;
  plays: number;
  compo_id: number;
  created: Date;
  title: string;
  description: string;
  url: string;
  anonymous: boolean;
  uploaded_url: string | undefined;
  hidden: boolean;
  downloadable: boolean;
  followed_theme: boolean;
  is_judged: boolean;
  is_joke: boolean;
  mod_comments: string;
  downloads: number;
  type: EntryType;

  comments: number;
  hearts: number;
  reviews: number;

  overall_score: number;

  user_id_1: number | undefined;
  user_id_2: number | undefined;
  user_id_3: number | undefined;
  user_id_4: number | undefined;
  user_id_5: number | undefined;

  user_id_0_conf: CollabConfirmationState;
  user_id_1_conf: CollabConfirmationState;
  user_id_2_conf: CollabConfirmationState;
  user_id_3_conf: CollabConfirmationState;
  user_id_4_conf: CollabConfirmationState;
  user_id_5_conf: CollabConfirmationState;

  secret_santa_recipient_user_id: number | undefined;
  secret_santa_recipient_external_user_name: string | undefined;
  secret_santa_prompt_text: string | undefined;
}

export class Entry extends Row<EntryJSON> implements EntryJSON {
  declare id: number;

  declare user_id: number;
  declare compo_id: number;
  declare created: Date;
  declare title: string;
  declare description: string;
  declare followed_theme: boolean;
  declare is_judged: boolean;
  declare is_joke: boolean;
  declare plays: number;
  declare url: string;
  declare anonymous: boolean;
  declare uploaded_url: string | undefined;
  declare hidden: boolean;
  declare downloadable: boolean;
  declare downloads: number;
  declare type: EntryType;
  declare mod_comments: string;

  declare comments: number;
  declare hearts: number;
  declare reviews: number;

  declare overall_score: number;

  declare user_id_0_conf: CollabConfirmationState;
  declare user_id_1_conf: CollabConfirmationState;
  declare user_id_2_conf: CollabConfirmationState;
  declare user_id_3_conf: CollabConfirmationState;
  declare user_id_4_conf: CollabConfirmationState;
  declare user_id_5_conf: CollabConfirmationState;

  declare user_id_1: number | undefined;
  declare user_id_2: number | undefined;
  declare user_id_3: number | undefined;
  declare user_id_4: number | undefined;
  declare user_id_5: number | undefined;

  declare secret_santa_recipient_user_id: number | undefined;
  declare secret_santa_recipient_external_user_name: string | undefined;
  declare secret_santa_prompt_text: string | undefined;

  constructor(props: EntryJSON) {
    super(props);

    this.created = new Date(this.created);
  }

  get linkToEntry(): string {
    return "/entry/" + this.id;
  }

  /**
   * Probably not what you want, as this also includes
   * userids that are not confirmed.
   */
  get allUserIds(): number[] {
    const result = [];

    if (this.user_id) {
      result.push(this.user_id);
    }
    if (this.user_id_1) {
      result.push(this.user_id_1);
    }
    if (this.user_id_2) {
      result.push(this.user_id_2);
    }
    if (this.user_id_3) {
      result.push(this.user_id_3);
    }
    if (this.user_id_4) {
      result.push(this.user_id_4);
    }
    if (this.user_id_5) {
      result.push(this.user_id_5);
    }

    return result;
  }

  get confirmedUserIds(): number[] {
    const result = [];

    if (this.user_id) {
      result.push(this.user_id);
    }
    if (this.user_id_1 && this.user_id_1_conf === "CONFIRMED") {
      result.push(this.user_id_1);
    }
    if (this.user_id_2 && this.user_id_2_conf === "CONFIRMED") {
      result.push(this.user_id_2);
    }
    if (this.user_id_3 && this.user_id_3_conf === "CONFIRMED") {
      result.push(this.user_id_3);
    }
    if (this.user_id_4 && this.user_id_4_conf === "CONFIRMED") {
      result.push(this.user_id_4);
    }
    if (this.user_id_5 && this.user_id_5_conf === "CONFIRMED") {
      result.push(this.user_id_5);
    }

    return result;
  }

  get user_collab_confirmations(): CollabConfirmationState[] {
    const result: CollabConfirmationState[] = [];

    if (this.user_id) {
      result.push(this.user_id_0_conf);
    }
    if (this.user_id_1) {
      result.push(this.user_id_1_conf);
    }
    if (this.user_id_2) {
      result.push(this.user_id_2_conf);
    }
    if (this.user_id_3) {
      result.push(this.user_id_3_conf);
    }
    if (this.user_id_4) {
      result.push(this.user_id_4_conf);
    }
    if (this.user_id_5) {
      result.push(this.user_id_5_conf);
    }

    return result;
  }

  // MISTAKES WERE MADE.
  setConfByIndex(i: number, value: CollabConfirmationState): void {
    if (i === 0) {
      this.user_id_0_conf = value;
      return;
    }
    if (i === 1) {
      this.user_id_1_conf = value;
      return;
    }
    if (i === 2) {
      this.user_id_2_conf = value;
      return;
    }
    if (i === 3) {
      this.user_id_3_conf = value;
      return;
    }
    if (i === 4) {
      this.user_id_4_conf = value;
      return;
    }
    if (i === 5) {
      this.user_id_5_conf = value;
      return;
    }

    throw new Error("GOD HELP ME");
  }

  setUserIdByIndex(i: number, value: number | undefined): void {
    if (i === 0 && value !== undefined) {
      this.user_id = value;
      return;
    }
    if (i === 1) {
      this.user_id_1 = value;
      return;
    }
    if (i === 2) {
      this.user_id_2 = value;
      return;
    }
    if (i === 3) {
      this.user_id_3 = value;
      return;
    }
    if (i === 4) {
      this.user_id_4 = value;
      return;
    }
    if (i === 5) {
      this.user_id_5 = value;
      return;
    }

    throw new Error("GOD HELP ME");
  }
}
